/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDim4DiagMinIcon20Solid = forwardRef('ArrowDim4DiagMinIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M18.207 1.793a1 1 0 0 1 0 1.414L14.414 7H17a1 1 0 1 1 0 2h-4a2 2 0 0 1-2-2V3a1 1 0 1 1 2 0v2.586l3.793-3.793a1 1 0 0 1 1.414 0Z" }),
        React.createElement("path", { d: "m7 14.414-3.793 3.793a1 1 0 0 1-1.414-1.414L5.586 13H3a1 1 0 1 1 0-2h4a2 2 0 0 1 2 2v4a1 1 0 1 1-2 0v-2.586Z" }),
        React.createElement("path", { d: "M17 13h-2.586l3.793 3.793a1 1 0 0 1-1.414 1.414L13 14.414V17a1 1 0 1 1-2 0v-4a2 2 0 0 1 2-2h4a1 1 0 1 1 0 2Z" }),
        React.createElement("path", { d: "M3.207 1.793a1 1 0 0 0-1.414 1.414L5.586 7H3a1 1 0 0 0 0 2h4a2 2 0 0 0 2-2V3a1 1 0 0 0-2 0v2.586L3.207 1.793Z" })));
});
